import { render } from "./trends.vue?vue&type=template&id=4bba1bc6&scoped=true"
import script from "./trends.vue?vue&type=script&lang=js"
export * from "./trends.vue?vue&type=script&lang=js"

import "./trends.vue?vue&type=style&index=0&id=4bba1bc6&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bba1bc6"]])

export default __exports__